import React, {useState, useEffect, FC} from 'react';
import { connect, useDispatch } from 'react-redux';
import { useParams, Link } from 'react-router-dom';
import { getEvent, getFestivalEvent  } from '../../redux/actions/index';
import {convertChars, formatDate, formatTime} from '../../helpers/utils';
import debounce from 'lodash.debounce';
// @ts-ignore
import ReactFancyBox from '../common/FancyBox/ReactFancyBox';
import 'react-fancybox/lib/fancybox.css';
import { SingleEvent, EventTimeEntry, TicketUrl } from '../interfaces';
import { HOST_NAME, ROOT_ROUTE, API_URL } from '../../constants';
import {
    Social,
    VideoBlock,
    ContentBody,
    ContentTitle,
    SeeAlso, LinkObject,
} from '../common';
import PencilIcon from '../common/PencilIcon';
import {buildFestivalLink} from '../../helpers';
import {MainFooter} from '../common/footer'
import { EventOsmWidget } from './event-osm-widget';

type EventScheduleProps = {
    schedule: {
    startDate: number
    place: string
    city: string
    county: string
    internalUrl:string
    }[]
    className?: string
}

const EventSchedule = (props: EventScheduleProps) => {
    const { schedule, className } = props;
    return <div className={`event-schedule-list ${className?className:''}`}>
        {schedule.map((element,idx) => {
            return (

                    <div className='event-schedule-item' key={idx}>
                        <Link to={`${ROOT_ROUTE}/places/${element.internalUrl}`}>
                            <div className='date-header'>{formatDate(element.startDate) + ' ' + formatTime(element.startDate)}</div>
                            <div className='place'>{`${element.place}, ${element.city}, ${element.county}`}</div>
                        </Link>
                    </div>

            )}
        )}
    </div>

}

type ConcertListProps = {
    items:  LinkObject[]
    className?: string|null
}

const ConcertsList:FC<ConcertListProps> = ({items, className}) => {
    return <div className={`concert-list ${className?className:''}`}>
        { items.map((item, idx) => (
            <div className='concert-list-item' key={`${item.text}_${idx}`}>
                <a href={`${ROOT_ROUTE}/event/${item.url}`}>
                    <div className='place'>{item.text}</div>
                </a>
                { item.time ?
                   <div className='place'>
                       {formatDate(item.time.start)}, {item.time.place.name_nat}
                   </div> :
                  null }
            </div>
        )) }
    </div>
}

const BuyTicket = (props: {tickets: TicketUrl[]}) => {
    const [ showList, setShowList ] = useState(false);
    const { tickets } = props;
    const listNotShowButton = ['www.apollokino.ee'];
    const showButton = () => {
        if (!tickets || !tickets.length) {
            return false;
        }
        if (!tickets[0].provider || listNotShowButton.includes(tickets[0].provider.name) ) {
            return false;
        }
        return true;
    }
    if (!showButton()) {
        return null;
    }
    return (

        <div className="tickets-list">
            <div className='event-buy-ticket' onClick={() => setShowList(!showList)}>
                <span className="ticket-btn-title">OSTA</span>
            </div>
            {showList &&
            <div className="tickets-providers">
                { tickets.map((ticket:TicketUrl ,idx:number) => {
                    return <div key={idx}>
                        <a href={ticket.ticketurl} title={ticket.name} target='_blank' onClick={() => setShowList(!showList)}>
                            {!ticket.provider.logo ?
                                <span className="ticket-provider">{ticket.provider.name}</span>:
                                <img src={`${API_URL}/${ticket.provider.logo}`} alt={ticket.provider.name} />
                            }
                        </a>
                    </div>
                })}
            </div> }
        </div>

    )
}



const makeSchedule = (event: SingleEvent | null) => {
    if (!event || !event.times) {
        return [];
    }

    const result = event.times.map ((time: EventTimeEntry) => {
        return  {
            startDate: time.start,
            place: time.place.name_nat,
            city: time.place.city.name_nat,
            county: time.place.city.county.name_nat,
            internalUrl: time.place.internalurl,
            price: time.price,
        }
    });
    return result;
}

const makeConcertList = (event: SingleEvent | null): LinkObject[] | null=> {
    if (!event || !event.attributes_nat.festival_events) return null;
    const {festival_events} = event.attributes_nat;
    return festival_events.map( (ev:SingleEvent) => (
        {
            url : ev.internalurl,
            text: ev.name_nat,
            time: ev.times && ev.times.length > 0 ? ev.times[0]:null
        }
    ));
}


const EventView = (props: any) => {

    const [selectedEvent, setSelectedEvent] = useState<SingleEvent | null>(null);
    const [festival, setFestival] = useState<LinkObject | null>(null);
    const [concerts, setConcerts] = useState<LinkObject[] | null>(null);
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    // @ts-ignore
    const {alias: internalUrl} = useParams();
    const [relatedList, setRelatedList] = useState<LinkObject[] | null>(null);

    const dispatch = useDispatch()
    const {singleEvent, festivalEvent } = props

    useEffect(() => {
        if (singleEvent !== selectedEvent) {
            setSelectedEvent(singleEvent);
            const f = buildFestivalLink(singleEvent);
            setFestival(f);
            setConcerts(makeConcertList(singleEvent));
            if (f && f.url) {
                dispatch(getFestivalEvent(f.url));
            } else {
                dispatch(getFestivalEvent(null));
            }
        }

        if (singleEvent) {
            if (internalUrl && singleEvent.internalurl !== internalUrl) {
                dispatch(getEvent(internalUrl));
            }
        } else {
            dispatch(getEvent(internalUrl));
        }
        return () => {
            setSelectedEvent(null);
            setConcerts(null);
            setFestival(null);
        }
    },[singleEvent]);

    useEffect(() => {
        setRelatedList(makeConcertList(festivalEvent));
        return () => {
            setRelatedList(null);
        }
    },[festivalEvent]);

    const schedule = makeSchedule(selectedEvent);
    const ticket = selectedEvent && selectedEvent.ticketurl.length ? true : false;
    const ticketPrice = schedule.find(sc => sc.price && sc.price !== '')?.price || selectedEvent?.ticketinfo_nat || null;
    let description = '';
    if (selectedEvent && selectedEvent.description_nat) {
        description = selectedEvent.description_nat;
    }
    let coordinates: {lat: number; lng: number} | null = null;
    if (selectedEvent?.coordinates) {
        coordinates = {
            lat: parseFloat(selectedEvent?.coordinates.split(',')[0]),
            lng: parseFloat(selectedEvent?.coordinates.split(',')[1]),
        }
    }
    let places:{id:number, name:string, lat:number, lng:number}[] = [];
    if (selectedEvent?.times.length) {
        places = selectedEvent.times.map((ev, idx) => {
            return { id: idx, name: ev.place.name_nat, lat: ev.place.lat || 0, lng: ev.place.lng || 0 }
        });
    }

    window.onresize = debounce(() => {
        setScreenWidth(window.innerWidth);
    })

    const RenderMobile = () => {
        let image = null;
        let thumb = null;
        if (selectedEvent) {
            image = `${API_URL}${selectedEvent.image}`;
            thumb = `${API_URL}${selectedEvent.image}&w=360`;
        }
        return selectedEvent && selectedEvent.id && (selectedEvent.internalurl === internalUrl)?
        <div className="event-view-container">
            { selectedEvent.image ?
                <ReactFancyBox
                    image={image}
                    thumbnail={thumb}
                />
                    :null }
            { selectedEvent.edit_link ?
              <div className='edit-event mobile'>
                  <a href={`https://www.kultuurikava.ee:8443${selectedEvent.edit_link}`} target='_blank' rel='noopener noreferrer'>
                      Muuda
                  </a>
              </div>
              :null}
            <ContentTitle title={selectedEvent.name} festival={festival}/>
            { concerts ? <ConcertsList items={concerts} className='desktop-schedule' />:null}
            <ContentBody description={description} />
            { relatedList ?
              <>
                  <div/>
                  <ConcertsList items={relatedList} className='desktop-schedule' />
                  <div className='mb-4'/>
              </>
                          :
              null}
            { selectedEvent.videourl ?
                <VideoBlock videourl={selectedEvent.videourl} />:null }
            { ticketPrice ? <div className='event-ticket-price'>{ticketPrice}</div>:null }
            { ticket ? <BuyTicket tickets={selectedEvent.ticketurl}/>: null }
            { schedule ? <EventSchedule schedule={schedule} />: null}




        { selectedEvent.links.length ?
            <SeeAlso links={selectedEvent.links} />:null
        }
        { coordinates? <div className='map-container'><EventOsmWidget coordinates={coordinates} /></div>:null }
        <Social text={selectedEvent.name}/>
        <MainFooter />
        </div>:null
    }

    const RenderDesktop = () => {
        let image = null;
        let thumb = null;
        if (selectedEvent) {
            image = `${API_URL}${selectedEvent.image}`
            thumb = `${API_URL}${selectedEvent.image}&w=360`
        }

        return selectedEvent && selectedEvent.id && (selectedEvent.internalurl === internalUrl)?
            <div className="event-desktop">

        <div className="event-view-container desktop">
            { selectedEvent.edit_link ?
                <div className='edit-event'>
                    <a href={`https://www.kultuurikava.ee${selectedEvent.edit_link}`} target='_blank' rel='noopener noreferrer'>
                        <span className='mr-1'>Muuda</span>
                        <PencilIcon />
                    </a>
                </div>
              :null}
            <div className='left-column'>
                { selectedEvent.image ?
                    <ReactFancyBox
                        image={image}
                        thumbnail={thumb}
                    /> :null
                }
            </div>
            <div className='center-column'>
                <div className="page-header">
                    <ContentTitle
                        title={convertChars(selectedEvent.name)}
                        festival={festival}
                    />
                </div>
                { concerts ? <ConcertsList items={concerts} className='desktop-schedule' />:null}
                <ContentBody description={description} />
                { ticketPrice ? <div className='event-ticket-price'>{ticketPrice}</div>:null }
                { ticket ? <BuyTicket tickets={selectedEvent.ticketurl} />: null }
                { relatedList ?
                  <>
                    <div className="event-additional-info container">
                      <ConcertsList items={relatedList} className='desktop-schedule' />
                      <div className='mb-4'/>
                    </div>
                  </>
                              :
                  null}
                { selectedEvent.links.length ?
                    <SeeAlso links={selectedEvent.links} />:null
                }
                { selectedEvent.videourl ?
                <VideoBlock videourl={selectedEvent.videourl} desktop={true}/>:null }
                <Social text={selectedEvent.name}/>
            </div>
            <div className='right-column'>
                { schedule ? <EventSchedule schedule={schedule} className='desktop-schedule'/>: null}
                { coordinates? <div className='map-container'>
                    {/* <MapWidget coordinates={coordinates} desktop={true} coords={places}/> */}
                    <EventOsmWidget coordinates={coordinates} />
                </div>:null }
            </div>
        </div>
            <MainFooter />
            </div>:null
    }

    return screenWidth < 991 ? <RenderMobile /> : <RenderDesktop />


}

const mapStateToProps = (state: any) => {
    const { singleEvent } = state
    return state
}

export default connect(mapStateToProps, {getEvent})(EventView)
